import { render, staticRenderFns } from "./simOpenCxk.vue?vue&type=template&id=25265e68&scoped=true&"
import script from "./simOpenCxk.vue?vue&type=script&lang=js&"
export * from "./simOpenCxk.vue?vue&type=script&lang=js&"
import style0 from "./simOpenCxk.vue?vue&type=style&index=0&id=25265e68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25265e68",
  null
  
)

export default component.exports